export default "__VITE_ASSET__BhvYq$1f__"